module.exports = __webpack_public_path__ + "img/header-icon3.d2d3e74c.jpg";